import { IFilter } from '../Tools/IFilter';
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from '../Tools/FiltersController';


export class ShowForGraphicArtistsFilter implements IFilter {
    id: string;
    name?: string | null;
    type: string;
    nbColums?: number;
    controller: FiltersController;
    parentGroup: FilterGroup;
    isFirst: boolean;
    isLast: boolean;

    constructor(parentGroup: FilterGroup, isFirst: boolean, isLast: boolean, nbColumns: number) {
        this.id = 'showGraphicArtists';
        this.name = 'Objets pour les graphistes';
        this.type = 'showForGraphicArtists';
        this.isFirst = isFirst;
        this.isLast = isLast;
        this.nbColums = nbColumns;
        this.controller = new FiltersController();
        this.parentGroup = parentGroup;
    }

    html(): string {
        let html = '';
        
        if (this.isFirst) {
            html += '<div class="noPadding" style="display: flex;flex-direction: row; justify-content: space-around;" id="showFilters">'
        }
        html = `
        <div class="${FilterGroup.getColumParam(this.nbColums!)}" style="width: fit-content;height: fit-content;">
            <input id="showForGraphicArtists" class="btn-default" type="checkbox"> ${this.name}
        </div>
        `;
        if (this.isLast) {
            html += '</div>';
        }
        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            $('#showForGraphicArtists').prop('checked', FilterGroup.filters.showForGraphicArtists);
            this.controller.addEventListener('change', () => {
                let isChecked = $('#showForGraphicArtists').is(':checked');
                FilterGroup.filters.showForGraphicArtists = isChecked;
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            }, 'showForGraphicArtists');
        });
        return html;
    }

    // Done
    generateStringFilter(): string {
        if (FilterGroup.filters.showForGraphicArtists) {
            return('&q.pipeline.unrealState.in=cooked,ready');
        }
        else {
            return('&q.pipeline.unrealState.in=ready');
        }
    }

    destroy(): void {
        this.controller.destroy();
    }

}